import { useMemo } from 'react';
import { curry, pick, assoc, map } from 'ramda';

import content from 'locale/content/de/data.json';

const handleTable = curry((extraData, table) => ({ ...table, ...extraData[table.type] }));

export const useContent = () =>
  useMemo(() => {
    const getTable = handleTable(pick(['dataSources', 'dataObject'], content));

    return assoc(
      'items',
      map(
        (item) => ({
          ...item,
          ...(item.tables && { tables: map(getTable, item.tables) }),
          ...(item.subItems && {
            subItems: map((subItem) => ({ ...subItem, tables: map(getTable, subItem.tables) }), item.subItems),
          }),
        }),
        content.items
      ),
      content
    );
  }, []);
